/**
 * PUB-1649 — pozioma pozycja dymka `VxTooltip`.
 *
 * Dymek jest przenoszony do `body` i pozycjonowany absolutnie, więc nic go nie przytnie —
 * ale nic go też nie zatrzyma przed wyjechaniem poza ekran. Domyślne wyliczenie centruje dymek
 * na elemencie wyzwalającym, co przy SZEROKIM dymku (np. wielozdaniowa pomoc) i elemencie przy
 * krawędzi okna daje `left` ujemny albo większy niż szerokość okna — część tekstu jest wtedy
 * nieczytelna, choć technicznie wyrenderowana.
 *
 * Trzymamy to w osobnym module, bo to czysta arytmetyka: da się ją przetestować naprawdę,
 * bez montowania komponentu (w repo nie ma `@vue/test-utils`).
 */

/** Odstęp od krawędzi okna. Tyle samo, ile wynosi margines dymka w pionie. */
export const VIEWPORT_MARGIN = 8;

/**
 * Sprowadza wyliczone `left` do zakresu widocznego na ekranie.
 *
 * Dymek SZERSZY niż okno (bardzo wąskie ekrany) dostaje sam margines — wtedy nie ma zakresu
 * do zaciśnięcia, a start od lewej krawędzi jest jedynym czytelnym wyborem.
 *
 * @param {number} left wyliczona pozycja lewej krawędzi dymka
 * @param {number} tooltipWidth szerokość dymka
 * @param {number} viewportWidth szerokość okna
 * @param {number} [margin] odstęp od krawędzi
 * @returns {number}
 */
export function clampHorizontal(left, tooltipWidth, viewportWidth, margin = VIEWPORT_MARGIN) {
  const value = Number(left);

  if (!Number.isFinite(value)) {
    return margin;
  }

  const width = Number(tooltipWidth) || 0;
  const viewport = Number(viewportWidth) || 0;
  const rightLimit = viewport - width - margin;

  if (rightLimit <= margin) {
    return margin;
  }

  return Math.min(Math.max(value, margin), rightLimit);
}
